import { render, staticRenderFns } from "./UnreadMessagesLink.vue?vue&type=template&id=38b46801"
import script from "./UnreadMessagesLink.vue?vue&type=script&lang=js"
export * from "./UnreadMessagesLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports